import Vue from 'vue'

Vue.filter('addYuan', function (value) {
  return value ? value + '元' : ''
})
